import { render, staticRenderFns } from "./accountList.vue?vue&type=template&id=c04d1124&scoped=true"
import script from "./accountList.vue?vue&type=script&lang=js"
export * from "./accountList.vue?vue&type=script&lang=js"
import style0 from "./accountList.vue?vue&type=style&index=0&id=c04d1124&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04d1124",
  null
  
)

export default component.exports